import type { ReactNode } from "react"
import { useState } from "react"
import { t } from "@lingui/core/macro"
import { Profile } from "../../../components/common/atoms/Icons/Chat"
import { addPageAction } from "../../../utils/newrelic"
import { useMessagingView } from "../hooks/useMessagingView"
import { HorizontalPosition, Menu, MenuItem, VerticalPosition } from "../Menu"
import { classNames, handleProfileNavigation } from "../utils"
import styles from "./UserMenu.module.scss"

type UserMenuProps = {
    /**
     * Username for the user profile
     */
    username: string
    /**
     * Toggle element containing user avatar and info
     */
    toggle: ReactNode
}

export function UserMenu({ username, toggle }: UserMenuProps) {
    const [isOpen, setIsOpen] = useState(false)
    const messagingView = useMessagingView()

    const containerClassNames = messagingView.isDesktopUnified
        ? styles.unifiedDesktop
        : undefined

    return (
        <div className={classNames(styles.container, containerClassNames)}>
            <Menu
                toggle={
                    <div
                        className={classNames(styles.toggleContainer, {
                            [styles.active]: isOpen,
                        })}
                        data-testid="user-menu-toggle-container"
                    >
                        {toggle}
                    </div>
                }
                isOpen={isOpen}
                onOpenChange={setIsOpen}
                verticalPosition={VerticalPosition.Bottom}
                horizontalPosition={HorizontalPosition.Right}
                toggleClassName={styles.menuToggle}
                menuClassName={styles.userMenuDropdown}
                data-testid="user-menu-container"
            >
                <MenuItem
                    icon={<Profile height={20} width={20} />}
                    text={t`View Profile`}
                    onClick={() => {
                        addPageAction("DmViewProfile")
                        setIsOpen(false)
                        handleProfileNavigation({
                            username,
                            isDesktop: messagingView.isDesktopConversation,
                        })
                    }}
                    data-testid="view-profile-menu-item"
                />
            </Menu>
        </div>
    )
}
